define(["../nlgPasswordModule", "text!./nlgPasswordConfirmation.html"], function (nlgPasswordModule, template) {
    "use strict";

    return nlgPasswordModule.directive("nlgPasswordConfirmation", ["nlgPasswordService", "passwordConfig", function (nlgPasswordService, passwordConfig) {
        return {
            restrict: "E",
            scope: {
                password: "=",
                confirmPassword: "=",
                placeholder: "@?",
                placeholderConfirmPassword: "@?",
                name: "@",
                nameConfirmPassword: "@",
                id: "@",
                idConfirmPassword: "@",
                cy: "@",
                cyConfirmation: "@",
                fullInputFill: "<?"
            },
            template: template,
            controller: ["$scope", function ($scope) {
                $scope.isHidePassword = true;
                $scope.placeholder = $scope.placeholder ? $scope.placeholder : " ";
                $scope.placeholderConfirmPassword = $scope.placeholderConfirmPassword ? $scope.placeholderConfirmPassword : " ";
                $scope.showValidationTooltip = passwordConfig.isShowValidationTooltip() || false;
                $scope.getInputType = function () {
                    if (!$scope.isHidePassword) {
                        return "text";
                    }
                    return "password";
                };

                $scope.getEyeClass = function () {
                    if (!$scope.isHidePassword) {
                        return "fa fa-eye";
                    }
                    return "fa fa-eye-slash";
                };

                $scope.getIconClass = function () {
                    if (!$scope.password) {
                        return "fa-exclamation-circle text-muted";
                    }
                    return nlgPasswordService.isValidPassword($scope.password) ? "fa-check-circle text-primary" : "fa-times-circle text-danger";
                };

                $scope.isValidPassword = function () {
                    if (!$scope.password && !$scope.confirmPassword) {
                        return true;
                    }
                    return $scope.password === $scope.confirmPassword;
                };
            }]
        };
    }]);
});